


























import { Component, Vue } from 'vue-property-decorator';
import IdentityData from '@/ts/IdentityData';
import { Actions } from '@/ts/store/Constants';

@Component
export default class IdentitiesAside extends Vue {
    constructor() {
        super();
    }

    get selectedIdentity(): IdentityData {
        return this.$store.getters['Identities/getSelectedIdentity'];
    }

    get identities(): IdentityData[] {
        return this.$store.getters['Identities/getIdentities'].filter((identity: IdentityData) => identity.userType === 'staff');
    }

    public switchIdentity(identity: IdentityData) {
        this.$store.dispatch(Actions.SWITCH_IDENTITY, {vue: this, identity});
    }
}
